<template>
  <div class="booking-create-container">
    <h2>添加预订</h2>
    <el-card shadow="hover">
      <el-form
        :model="bookingForm"
        :rules="rules"
        ref="bookingFormRef"
        label-position="top"
        label-width="120px"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="用户ID" prop="user_id">
              <el-input v-model="bookingForm.user_id" placeholder="请输入用户ID" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="房间ID" prop="room_id">
              <el-input v-model="bookingForm.room_id" placeholder="请输入房间ID" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="预订号" prop="booking_no">
              <el-input v-model="bookingForm.booking_no" placeholder="请输入预订号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-select v-model="bookingForm.status" placeholder="请选择状态">
                <el-option label="待确认" value="pending" />
                <el-option label="已确认" value="confirmed" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="入住日期" prop="check_in_date">
              <el-date-picker
                v-model="bookingForm.check_in_date"
                type="datetime"
                placeholder="选择入住日期"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="退房日期" prop="check_out_date">
              <el-date-picker
                v-model="bookingForm.check_out_date"
                type="datetime"
                placeholder="选择退房日期"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="总金额" prop="total_amount">
              <el-input v-model="bookingForm.total_amount" type="number" placeholder="请输入总金额" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客人姓名" prop="guest_name">
              <el-input v-model="bookingForm.guest_name" placeholder="请输入客人姓名" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="客人电话" prop="guest_phone">
              <el-input v-model="bookingForm.guest_phone" placeholder="请输入客人电话" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入住人数" prop="adult_count">
              <el-input v-model="bookingForm.adult_count" type="number" placeholder="请输入入住人数" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="儿童人数" prop="child_count">
              <el-input v-model="bookingForm.child_count" type="number" placeholder="请输入儿童人数" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否含早餐" prop="breakfast_included">
              <el-switch v-model="bookingForm.breakfast_included" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="特殊要求" prop="special_requests">
              <el-input v-model="bookingForm.special_requests" type="textarea" placeholder="请输入特殊要求" rows="4" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <div class="form-actions">
          <el-button @click="handleCancel">取消</el-button>
          <el-button type="primary" @click="handleSubmit">提交</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import request from '../../api/axios';

export default {
  name: 'BookingCreate',
  setup() {
    const router = useRouter();
    const bookingFormRef = ref(null);
    
    const bookingForm = ref({
      user_id: '',
      room_id: '',
      booking_no: '',
      status: 'pending',
      check_in_date: new Date(),
      check_out_date: new Date(),
      total_amount: 0,
      guest_name: '',
      guest_phone: '',
      adult_count: 1,
      child_count: 0,
      breakfast_included: false,
      special_requests: ''
    });
    
    const rules = {
      user_id: [
        { required: true, message: '请输入用户ID', trigger: 'blur' },
        { type: 'number', message: '用户ID必须是数字', trigger: 'blur' }
      ],
      room_id: [
        { required: true, message: '请输入房间ID', trigger: 'blur' },
        { type: 'number', message: '房间ID必须是数字', trigger: 'blur' }
      ],
      booking_no: [
        { required: true, message: '请输入预订号', trigger: 'blur' }
      ],
      status: [
        { required: true, message: '请选择状态', trigger: 'change' }
      ],
      check_in_date: [
        { required: true, message: '请选择入住日期', trigger: 'change' }
      ],
      check_out_date: [
        { required: true, message: '请选择退房日期', trigger: 'change' }
      ],
      total_amount: [
        { required: true, message: '请输入总金额', trigger: 'blur' },
        { type: 'number', min: 0, message: '总金额必须大于等于0', trigger: 'blur' }
      ],
      guest_name: [
        { required: true, message: '请输入客人姓名', trigger: 'blur' }
      ],
      guest_phone: [
        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
      ],
      adult_count: [
        { required: true, message: '请输入入住人数', trigger: 'blur' },
        { type: 'number', min: 1, message: '入住人数必须大于等于1', trigger: 'blur' }
      ]
    };
    
    // 提交表单
    const handleSubmit = async () => {
      if (!bookingFormRef.value) return;
      
      await bookingFormRef.value.validate(async (valid) => {
        if (valid) {
          try {
            await request({
              url: '/manage/bookings',
              method: 'post',
              data: bookingForm.value
            });
            ElMessage.success('预订创建成功');
            router.push('/bookings/list');
          } catch (error) {
            ElMessage.error('预订创建失败');
            console.error(error);
          }
        } else {
          return false;
        }
      });
    };
    
    // 取消操作
    const handleCancel = () => {
      router.push('/bookings/list');
    };
    
    return {
      bookingForm,
      bookingFormRef,
      rules,
      handleSubmit,
      handleCancel
    };
  }
};
</script>

<style scoped>
.booking-create-container {
  padding: 20px;
}

.booking-create-container h2 {
  margin-bottom: 20px;
  color: #333;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.form-actions .el-button {
  margin-left: 10px;
}
</style>